import { useEffect, useState } from 'react';
import api from '@/lib/api';

// Cash expense: which open POS drawer paid it, or "Not from a drawer". Shown only when the branch has open drawers.
export function DrawerSourceSelect({ branchId, value, onChange }) {
  const [drawers, setDrawers] = useState([]);
  useEffect(() => {
    if (!branchId) { setDrawers([]); return; }
    api.get('/expenses/open-drawers', { params: { branch_id: branchId } }).then(({ data }) => setDrawers(data || [])).catch(() => setDrawers([]));
  }, [branchId]);
  if (!drawers.length) return null;
  return (
    <div className="mt-1.5" data-testid="expense-drawer-source">
      <label className="text-[11px] text-muted-foreground">Paid from</label>
      <select className="w-full border rounded-md h-9 px-2 text-sm bg-background" value={value || 'none'} onChange={(e) => onChange(e.target.value)} data-testid="expense-drawer-select">
        <option value="none">Not from a drawer (branch cash / back office)</option>
        {drawers.map((d) => <option key={d.id} value={d.id}>Drawer of {d.cashier_name || 'cashier'} (open since {String(d.started_at || '').slice(11, 16)})</option>)}
      </select>
    </div>
  );
}
